import { SvgIcon, SxProps } from "@mui/material";

import SvgEllipsisIcon from "jsx:../../../Images/Icons/FontAwesome/light/ellipsis.svg";

export function MoreHorizontalIcon(props: SxProps) {
    return <SvgIcon component={SvgEllipsisIcon} inheritViewBox sx={props} />;
}
